import React, { useEffect } from 'react';
import { useUrlSearchParams } from 'use-url-search-params';
import AppContentView from '@crema/components/AppContentView';
import generateRoutes from '@crema/helpers/RouteGenerator';
import { Layouts } from '@crema/components/AppLayout';
import { useAuthUser } from '@crema/hooks/AuthHooks';
import {
  useLayoutActionsContext,
  useLayoutContext,
} from '@crema/context/LayoutContextProvider';
import { useSidebarActionsContext } from '@crema/context/SidebarContextProvider';
import {
  anonymousStructure,
  anonymousStructureForUsers,
  authorizedStructure,
  unAuthorizedStructure,
  unAuthorizedStructureForUsers,
} from '../AppRoutes';
import { Navigate, useRoutes } from 'react-router-dom';
import routesConfig from '../AppRoutes/routeconfig';
import { authRouteConfig } from '../AppRoutes/AuthRoutes';
import { errorPagesConfigs } from '../AppRoutes/ErrorPagesRoutes';
const AppLayout = () => {
  const { navStyle } = useLayoutContext();

  const { user, isAuthenticated } = useAuthUser();
  const { updateNavStyle } = useLayoutActionsContext();
  const { updateMenuStyle, setSidebarBgImage } = useSidebarActionsContext();
  const AppLayout = Layouts[navStyle];
  const [params] = useUrlSearchParams();

  const unAuthorizedStructureForEnterprise = {
    fallbackPath: `/mappings/${user?.enterpriseId || ''}`,
    routes: authRouteConfig,
  };
  const anonymousStructureForEnterprise = {
    routes: errorPagesConfigs.concat([
      {
        path: '/',
        element: <Navigate to={`/mappings/${user?.enterpriseId || ''}`} />,
      },
      {
        path: '*',
        element: <Navigate to="/error-pages/error-404" />,
      },
    ]),
  };

  const generatedRoutes = generateRoutes({
    isAuthenticated: isAuthenticated,
    userRole: user?.role,
    unAuthorizedStructure: user?.roles.includes('SUPER_ADMIN')
      ? unAuthorizedStructureForUsers
      : (user?.roles.includes('ENTERPRISE_ADMIN') ? unAuthorizedStructureForEnterprise : unAuthorizedStructure),
    authorizedStructure,
    anonymousStructure: user?.roles.includes('SUPER_ADMIN')
      ? anonymousStructureForUsers
      : (user?.roles.includes('ENTERPRISE_ADMIN') ? anonymousStructureForEnterprise : anonymousStructure),
  });
  const routes = useRoutes(generatedRoutes);

  useEffect(() => {
    if (params.layout) updateNavStyle(params.layout as string);
    if (params.menuStyle) updateMenuStyle(params.menuStyle as string);
    if (params.sidebarImage) setSidebarBgImage(true);
  }, [params, setSidebarBgImage, updateNavStyle, updateMenuStyle]);

  return (
    <>
      {isAuthenticated ? (
        <AppLayout routes={routes} routesConfig={routesConfig} />
      ) : (
        <AppContentView routes={routes} />
      )}
    </>
  );
};

export default AppLayout;
